var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"supply"},[(_vm.facility=='app')?_c('div',{staticClass:"app"},[_c('App',{attrs:{"barList":_vm.barlist}})],1):_c('div',[_c('Pc',{attrs:{"barList":_vm.barlist}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }